function trfGetDate(options, other) {
    var now, y, m, d, day, month, year, split, isCallback;
    var defaultOpt = {
        year: 0,
        month: 0,
        day: 0,
        split: '-'
    };
    if(Object.prototype.toString.call(options) === '[object Object]' || options === undefined) {
        options = $.extend({}, defaultOpt, options);
        year = options.year;
        month = options.month;
        day = options.day;
        split = options.split;
    } else if(typeof options === 'string') {
        isCallback = typeof other[1] === 'function';
        switch (options) {
            case 'year':
                year = isCallback ? other[1].apply(this, other) : +other[1] || defaultOpt.year;
                break;
            case 'month':
                month = isCallback ? other[1].apply(this, other) : +other[1] || defaultOpt.month;
                break;
            case 'day':
                day = isCallback ? other[1].apply(this, other) : +other[1] || defaultOpt.day;
                break;
            case 'split':
                split = isCallback ? other[1].apply(this, other) : +other[1] || defaultOpt.split;
                break;
            default:
                break;
        }
        year = year || defaultOpt.year;
        month = month || defaultOpt.month;
        day = day || defaultOpt.day;
        split = split || defaultOpt.split;
    }
    now = new Date();
    now.setYear( now.getFullYear() + (year) );//获取addYear年后的日期
    now.setMonth( now.getMonth()+(month) );//获取addMonth月后的日期
    now.setDate( now.getDate()+ (day) );//获取addDay天后的日期
    y = now.getFullYear();
    m = now.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    d = now.getDate();
    d = d < 10 ? '0' + d : d;
    this.date = y + split + m + split + d;
}

module.exports =  function (options) {
    return (new trfGetDate(options, arguments)).date;
};


//////////////////
// WEBPACK FOOTER
// ./src/components/get-date.js
// module id = 188
// module chunks = 0